// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ing-selection {\n    border-top: 1px solid;\n    border-color: #e6e6e6;\n    text-align: center;\n    padding-top: 10px;\n}", ""]);
// Exports
module.exports = exports;
